export default function searchResults(state = {}, action) {
  switch (action.type) {
    case 'RECEIVE_SEARCH_RESULTS':
      return {
        products: action.payload.results.products,
        metadata: action.payload.results.metadata,
        exact_matching_variant: action.payload.results.exact_matching_variant,
        upc_or_sku_search: action.payload.results.upc_or_sku_search,
      }

    case 'RESET_SEARCH_RESULTS':
      return {}

    default:
      return state
  }
}
